import { TWhoAmIApiResponse } from "@/schemas/api"

export const DEFAULT_WHO_AM_I_API_RESPONSE: TWhoAmIApiResponse = {
  id: -1,
  mail: "dev@ring.io",
}

// Defaults for the API calls
export const LAUNCHER_APP_PATH: string = "launcher-app"
export const REMOTE_APP_PATH: string = "remote-app"

// Defaults for the .env file
export const DEFAULT_BASE_API_URL: string = "https://newtesting2.ring.io"
export const DEFAULT_NODE_ENV: string = "development"
